// scroll toggle on body
$(function() {
    var body = document.querySelector('body');
    var hamburger = document.querySelector('.hamburger');
    var navbar = document.querySelector('.i4-site__navbar');
    var nav = document.querySelector('.i4-site__navbar-nav');

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll > 1) {
            body.classList.add('scrolled');
        } else {
            body.classList.remove('scrolled');
        }
    });

    var scroll = $(window).scrollTop();
    if (scroll > 0) {
        body.classList.add('scrolled');
    }

    stickybits('.i4-site__navbar');

    if (hamburger && nav) {
        // toggle navigation state on hamburger click
        hamburger.onclick = function () {
            if (nav.classList.contains('open')) {
                hamburger.classList.remove('is-active');
                navbar.classList.remove('open');
                nav.classList.remove('open');
                body.classList.remove('navbar');
            } else {
                hamburger.classList.add('is-active');
                navbar.classList.add('open');
                nav.classList.add('open');
                body.classList.add('navbar');
            }
        };

        // toggle navbar and hamburger color on scroll
        window.onscroll = function () {
            if (window.scrollY >= 25) {
                if (navbar && !navbar.classList.contains('scrolled')) {
                    navbar.classList.add('scrolled');
                    hamburger.classList.add('scrolled');
                }
            } else {
                if (navbar && navbar.classList.contains('scrolled')) {
                    navbar.classList.remove('scrolled');
                    hamburger.classList.remove('scrolled');
                }
            }
        };
    }
});
